export function clipboardModifyHandler(e: ClipboardEvent) {
  if (!e.clipboardData) {
    return;
  }

  let selectedText = window.getSelection().toString();
  selectedText = `${selectedText} - Информация скопирована с cian.ru: ${location.href}`;
  e.clipboardData.setData('text/plain', selectedText);
  e.preventDefault();
}
